import { Provider } from '@angular/core';

import { NetworkRepositoryImpl } from '@app/data/repositories/network/network.repository';
import { NETWORK_REPOSITORY } from '@app/domain/repositories/network/network.repository.contract';

export const networkRepositoryProvider: Provider = {
  provide: NETWORK_REPOSITORY,
  useClass: NetworkRepositoryImpl
};
